import { render, staticRenderFns } from "./SliderBlock.vue?vue&type=template&id=5b6f9546&scoped=true"
import script from "./SliderBlock.vue?vue&type=script&lang=js"
export * from "./SliderBlock.vue?vue&type=script&lang=js"
import style0 from "./SliderBlock.vue?vue&type=style&index=0&id=5b6f9546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f9546",
  null
  
)

export default component.exports